import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
// import saveAs from 'file-saver';

@Component({
  selector: 'app-help-info',
  templateUrl: './help-info.component.html',
  styleUrls: ['./help-info.component.scss']
})
export class HelpInfoComponent implements OnInit {


  isLoading = false;
  docFiles: any[] = [];
  videoFiles: any[] = [];

  downloadingFiles: string[] = [];

  constructor(
    private msg: NzMessageService,
    private translateServ: TranslateService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.isLoading = true;
    const videoUrl = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetFileToken.url}?filePurpose=Video`;
    const docUrl = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetFileToken.url}?filePurpose=Document`;
    const videoRequest = this.WebApiService.doGet(videoUrl);
    const docRequest = this.WebApiService.doGet(docUrl);
    Promise.all([
      docRequest.toPromise(),
      videoRequest.toPromise()
    ]).then(res => {
      if (res[0].status == '200') {
        this.docFiles = res[0].data ?? [];
      } else {
        this.msg.error(res[0].msg || this.translateServ.instant('ServerError'));
      }
      if (res[1].status == '200') {
        this.videoFiles = res[1].data ?? [];
      } else {
        this.msg.error(res[1].msg || this.translateServ.instant('ServerError'));
      }
      this.isLoading = false;
    }).catch(err => {
      this.isLoading = false;
      this.msg.error(err?.message || err?.msg || this.translateServ.instant('ServerError'));
    });
  }

  download(data: any) {
    this.downloadingFiles.push(data.fileToken);
    this.WebApiService.downloadFileByToken(data.fileToken).subscribe(res => {
      // const contentType = res.headers.get('Content-Type');
      let fileName = data.fileName + data.fileType;
      // const file = new window.File([res.body], fileName, { type: contentType });
      // saveAs(file, fileName);
       this.downloadFile8(res, data.fileName);
      this.downloadingFiles = this.downloadingFiles.filter(f => f != data.fileToken);
    });
  }

    downloadFile8(blob, fileName) {
    // 获取response headers数据
    // const name = blob.headers("Content-Disposition");
    const nav = (window.navigator as any);
    if (nav.msSaveOrOpenBlob) {
      // ie
      nav.msSaveOrOpenBlob(blob, fileName);
    } else {
      // 只支持firefox,chrome
      let aLink = document.createElement('a');
      // let blob = this.base64ToBlob(content, fileType); //new Blob([content]);
      let evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    }
  }

  isDownloading(data: any): boolean {
    return this.downloadingFiles.includes(data.fileToken);
  }
}
